import { NavLink, useLocation } from 'react-router-dom';
import { formatNumber } from '@bookingdei/i18n/format-number';
import { useLanguage } from './language-context';
import { Icon } from './icon';
import { tabItems, moreItems, navItemForPath } from './nav-items';
import type { ShellBadges } from './nav-items';
import './tab-bar.css';

// Mobile tab bar (CB-17; Others.dc.html L319-346): Home · Bookings (badge) · Saved ·
// Reviews (badge) · More. More opens the More sheet (more-sheet.tsx) and reads as
// active while one of its pages is showing. Glass bar, safe-area aware; below the
// 760 px breakpoint only (tab-bar.css).
export function TabBar({ badges, onMore, moreOpen }: { badges: ShellBadges; onMore: () => void; moreOpen: boolean }) {
  const { t, lang } = useLanguage();
  const { pathname } = useLocation();
  const currentId = navItemForPath(pathname)?.id;
  const inMore = moreItems.some((it) => it.id === currentId);
  const moreCount = moreItems.reduce((n, it) => n + (it.badge ? badges[it.badge] : 0), 0);

  return (
    <nav className="tab-bar" aria-label={t('user.nav.primary')}>
      {tabItems.map((item) => {
        const count = item.badge ? badges[item.badge] : 0;
        return (
          <NavLink
            key={item.id}
            to={item.to}
            end={item.to === '/'}
            className={({ isActive }) => (isActive ? 'tab-bar__link is-active' : 'tab-bar__link')}
          >
            <Icon name={item.icon} size={20} />
            <span>{t(item.tabKey)}</span>
            {count > 0 && <span className="tab-bar__badge">{formatNumber(lang, count)}</span>}
          </NavLink>
        );
      })}
      <button
        type="button"
        className={inMore ? 'tab-bar__link is-active' : 'tab-bar__link'}
        aria-haspopup="dialog"
        aria-expanded={moreOpen}
        onClick={onMore}
      >
        <Icon name="more" size={20} />
        <span>{t('user.shell.tab.more')}</span>
        {moreCount > 0 && <span className="tab-bar__badge">{formatNumber(lang, moreCount)}</span>}
      </button>
    </nav>
  );
}
